/** @format */

import { Pipe, PipeTransform } from '@angular/core';

import { ProductSummarisedFeature } from '@product-reviews/data-access';

/**
 * @description
 * This pipe is used to format the "pros/cons" filters label.
 * It appends the total number of reviews mentioned in parentheses if available.
 */
@Pipe({
	name: 'featureLabel',
	standalone: true
})
export class FeatureLabelPipe implements PipeTransform {
	transform(feature: ProductSummarisedFeature | null | undefined): string {
		if (!feature?.feature) return '';

		const { feature: featureName } = feature;
		const total = feature.reviewsMentioned?.total;
		return total !== undefined && total !== null ? `${featureName} (${total})` : featureName;
	}
}
